import { Component, Input, ElementRef } from '@angular/core';
import { BaseToolComponent } from '../../base-tool.component';
import { DragulaService } from 'ng2-dragula';
import { Subscription } from 'rxjs';
import { LayerData } from 'src/app/data/configurator/layer/layer.data';
import { LabelData } from 'src/app/data/configurator/label/label.data';
import { ApplicationService } from 'src/app/services/application.service';
import { HistoryData } from 'src/app/data/configurator/history.data';
import { CommandData } from 'src/app/data/configurator/command.data';
import { ModalService } from 'src/app/services/modal.service';

@Component({
  selector: 'layers-panel',
  templateUrl: './layers-panel.component.html',
  host: {
    class: 'layers-panel'
  }
})
export class LayersPanelComponent extends BaseToolComponent {

  @Input() set label(data: LabelData) {
    if ((this._labelData && this._labelData != data) || !this._labelData) {
      this.clearCurrentLabel();
      this._labelData = data;
      this.setLabel();
    }
  }

  @Input() set layer(data: LayerData) {
    if (this._layerData != data) {
      this._layerData = data;
      this.setLayer();
    }
  }
  get layerData(): LayerData {
    return this._layerData;
  }

  public layers:Array<LayerData> = [];
  public LayerData = LayerData;

  private _dragulaSubs: any;

  /**
	 * Constructor
	 */
  constructor(
    private applicationService: ApplicationService,
    private dragulaService: DragulaService,
    private ref:ElementRef,
    private modalService:ModalService
  ) {
    super();
    this.dragulaService.createGroup('LAYERS', {
      mirrorContainer: this.ref.nativeElement,
      accepts: (el, target, source, sibling) => {
        if (sibling) {
          return true;
        } else {
          return !this.layers[this.layers.length - 1].locks.depth;
        }
      },
      moves: (el, container, handle) => {
        return handle.className.indexOf('layer__draggable') >= 0;
      }
    });
    this._dragulaSubs = new Subscription();
    this._dragulaSubs.add(dragulaService.drop('LAYERS')
      .subscribe(({ name, el, target, source, sibling }) => {
        let index = 0;
        let registered = false;
        for (var i: number = this.layers.length - 1; i >= 0; i--) {
          if (this.layers[i].index != index && !registered) {
            registered = true;
            HistoryData.add(this._labelData, this.layers[i], CommandData.ORDER_LAYER, this.layers[i].index);
          }
          this.layers[i].index = index;
          index++;
        }

        this.labelData.reorderTab(true);
      })
    );
    this._dragulaSubs.add(dragulaService.over('LAYERS')
      .subscribe(({ el, container }) => {

      })
    );
    this._dragulaSubs.add(dragulaService.out('LAYERS')
      .subscribe(({ el, container }) => {

      })
    );
  }

	/**
	 * On init
	 */
  ngOnInit() {

  }

  /**
	 * Set label
	 */
  protected setLabel(): void {
    if (this.labelData) {
      this.layers = this.labelData.layers.slice().reverse();
    }

    super.setLabel();
  }

  /**
	 * Set layer
	 */
  protected setLayer(): void {
    if (this._layerData) {

    }
  }

  /**
	 * Delete layer
	 */
  protected requestLayerDeletion(layerData:LayerData): void {
    this.modalService.open('modal-confirm-layer-deletion', { text: 'cfg_layerDeleteConfirmation', layer: layerData });
  }

  /**
	 * Delete layer
	 */
  public deleteLayer(layerData:LayerData): void {
    this.labelData.removeLayer(layerData);
    this.modalService.cancel('modal-confirm-layer-deletion');
  }

  /**
	 * Delete layer
	 */
  protected selectLayer(layerData: LayerData): void {
    this.applicationService.currentLayerData = layerData;
  }

  /**
 	 *  Label updated
 	 */
  protected labelUpdated(data: LayerData): void {
    super.labelUpdated(data);
  }

	/**
 	 *  Label updated
 	 */
  protected labelLayerAdded(data: LayerData): void {
    super.labelLayerAdded(data);

    if (this.labelData) {
      this.layers = this.labelData.layers.slice().reverse();
    }
  }

	/**
 	 *  Label updated
 	 */
  protected labelLayerRemoved(data: LayerData): void {
    super.labelLayerRemoved(data);

    if (this.labelData) {
      this.layers = this.labelData.layers.slice().reverse();
    }
  }

  /**
 	 *  Label updated
 	 */
  protected labelLayersReordered(): void {
    super.labelLayersReordered();
    this.layers = this.labelData.layers.slice().reverse();

  }

	/**
	* On destroy
	*/
  ngOnDestroy() {
    super.ngOnDestroy();
    this._dragulaSubs && this._dragulaSubs.unsubscribe();
    this.dragulaService.destroy('LAYERS');
  }
}
